import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';
import {
  InsertTaskCommentDocument,
  type InsertTaskCommentMutationVariables,
} from '@/graphql/generated/graphql';

export type TaskCommentInsertInput = InsertTaskCommentMutationVariables;

export const useInsertTaskComment = () => {
  const mutation = useMutation({
    mutationKey: ['insert-task-comment'],
    mutationFn: (variables: InsertTaskCommentMutationVariables) =>
      graphqlClient.request(InsertTaskCommentDocument, variables),
  });

  return {
    ...mutation,
    insertTaskComment: mutation.mutate,
    insertTaskCommentAsync: mutation.mutateAsync,
  };
};

export const INSERT_TASK_COMMENTS_MUTATION = InsertTaskCommentDocument;
